import idCard from './id-card'

export default {
  modules: {
    idCard
  }
}
